import { render, staticRenderFns } from "./LimitedCompanies.vue?vue&type=template&id=983964f4&scoped=true"
import script from "./LimitedCompanies.vue?vue&type=script&lang=js"
export * from "./LimitedCompanies.vue?vue&type=script&lang=js"
import style0 from "./LimitedCompanies.vue?vue&type=style&index=0&id=983964f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983964f4",
  null
  
)

export default component.exports